import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeReportTPP } from 'store/ducks/Reportings/types';
import { columns } from 'components/Columns/ReportTPPColumns';

interface reportDataProps {
  entityName: string;
}

const ReportTPPs: React.FC<reportDataProps> = ({ entityName }) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeReportTPP[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchReportTPPs(params);
      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const entityName = fetchedData.entity_name;

        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: entityName,
            add_ict_service_provider_identification_code:
              dataItem.add_ict_service_provider_identification_code,
            add_identification_code_type: dataItem.add_identification_code_type,
            alternative_providers_identified:
              dataItem.alternative_providers_identified,
            alternatives_exit: dataItem.alternatives_exit,
            criticality_assessment: dataItem.criticality_assessment,
            description: dataItem.description,
            dora_criticality: dataItem.dora_criticality,
            dora_regulator_criticality: dataItem.dora_regulator_criticality,
            dora_regulator_criticality_label:
              dataItem.dora_regulator_criticality_label,
            end_date: dataItem.end_date,
            entity_nature: dataItem.entity_nature,
            exit_plan_exists: dataItem.exit_plan_exists,
            headquarters_country: dataItem.headquarters_country,
            ict_service_provider_identification_code:
              dataItem.ict_service_provider_identification_code,
            ict_service_provider_lei: dataItem.ict_service_provider_lei,
            identification_code_type: dataItem.identification_code_type,
            iso_code: dataItem.iso_code,
            last_audit_date: dataItem.last_audit_date,
            local_regulator_criticality: dataItem.local_regulator_criticality,
            non_subst_reason: dataItem.non_subst_reason,
            notice_period: dataItem.notice_period,
            person_type: dataItem.person_type,
            possibility_of_reintegration: dataItem.possibility_of_reintegration,
            rank: dataItem.rank,
            recipient_identification_code:
              dataItem.recipient_identification_code,
            recipient_identification_type:
              dataItem.recipient_identification_type,
            start_date: dataItem.start_date,
            substitutability: dataItem.substitutability,
            substitutability_of_ict_provider:
              dataItem.substitutability_of_ict_provider,
            third_party_service_provider_legal_name:
              dataItem.third_party_service_provider_legal_name,
            third_party_service_provider_name:
              dataItem.third_party_service_provider_name,
            tpp_code_type: dataItem.tpp_code_type,
            ultimate_parent_identification_code:
              dataItem.ultimate_parent_identification_code,
            ultimate_parent_identification_code_type:
              dataItem.ultimate_parent_identification_code_type,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table columns={columns} dataSource={data} scroll={{ x: 1000, y: 430 }} />
    </>
  );
};

export default ReportTPPs;
